module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","exams":"Prüfungen"},"en":{"add":"Add","exams":"Exams"}}')
  delete Component.options._Ctor
}
